import type { Paths } from "type-fest";
import { z } from "zod";

import { zOutSchema2 } from "./common";

import { ListParams, Pagination } from "~/shared/zod";

const zOut = Pagination.Page.zSchema(zOutSchema2);
type Out = z.infer<typeof zOut>;

type Key = Paths<Out["items"][number]>;

const INCLUDED_KEYS = ["payment.isCompleted"] as const satisfies Key[];

const EXCLUDED_KEYS = ["payment"] as const satisfies Key[];

const zFieldsToSortBy = z.enum([
  ...zOutSchema2.keyof().exclude(EXCLUDED_KEYS).options,
  ...INCLUDED_KEYS,
]);
const FieldsToSortBy = zFieldsToSortBy.Enum;
type FieldsToSortBy = z.infer<typeof zFieldsToSortBy>;

const zIn = ListParams.zSchema(zFieldsToSortBy);
type In = z.infer<typeof zIn>;

export { FieldsToSortBy, zFieldsToSortBy, zIn, zOut };
export type { In, Out };
